import { AutogenModelEdiControl, AutogenRowEdiControl } from "./autogen/AutogenModelEdiControl";

export class ModelEdiControl extends AutogenModelEdiControl<RowEdiControl> {
	constructor() {
		super(RowEdiControl);
	}
}

export class RowEdiControl extends AutogenRowEdiControl {
}